/**
*
* StepThree
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Transition } from 'react-transition-group';

import appConfig from 'appConfig';
import { Button, CopyTextBox, AnchorLink } from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import enhanceWithChildrenHeight from 'hocs/enhanceWithChildrenHeight';

import { PageNavLink } from 'components/PageStyles';
import {
  GrowingWrapper,
  VerticalSeparator,
  StepActions,
} from './styles';
import messages from './messages';

const EnhancedGrowingWrapper = enhanceWithChildrenHeight(GrowingWrapper);

const StepThree = ({ active, back, pluginId }) => (
  <Transition
    in={active}
    timeout={300}
    unmountOnExit
  >
    {(state) => (
      <EnhancedGrowingWrapper transitionState={state}>
        <VerticalSeparator>
          <FormattedMessage {...messages.uploadText} />
        </VerticalSeparator>
        <VerticalSeparator>
          <CopyTextBox
            grey
            textType="code"
            value={messages.uploadCode}
            notificationLabel={intl.formatMessage(messages.copied)}
          />
        </VerticalSeparator>
        <VerticalSeparator>
          <FormattedMessage {...messages.developerKeyText} />
          <AnchorLink
            iconRight
            iconSize={18}
            icon="open_in_new"
            href={appConfig.getDeveloperDocsURL()}
            target="_blank"
          >
            <FormattedMessage {...messages.developerKeyLinkText} />
          </AnchorLink>
        </VerticalSeparator>
        <VerticalSeparator>
          <FormattedMessage {...messages.pluginIdText} />
        </VerticalSeparator>
        <VerticalSeparator>
          <CopyTextBox
            grey
            textType="code"
            value={pluginId}
            notificationLabel={intl.formatMessage(messages.copied)}
          />
        </VerticalSeparator>
        <VerticalSeparator>
          <FormattedMessage {...messages.finishedText} />
        </VerticalSeparator>
        <StepActions>
          <Button onClick={back}>
            <FormattedMessage {...messages.previousStep} />
          </Button>
          <PageNavLink to={`/plugins/${pluginId}`}>
            <Button primary>
              <FormattedMessage {...messages.done} />
            </Button>
          </PageNavLink>
        </StepActions>
      </EnhancedGrowingWrapper>
    )}
  </Transition>
);

StepThree.propTypes = {
  active: PropTypes.bool,
  back: PropTypes.func,
  pluginId: PropTypes.string,
};

export default StepThree;
